import {EmailDigestRestService} from './restServices/restServices';

var service = {};

service.updateEmailDigestSubscription = (
  subscribe,
  userToken,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  EmailDigestRestService.put(
    {
      endpoint: 'emailDigest',
      endpointParam: 'optOut',
    },
    {
      enableWeeklyDigest: subscribe,
      token: userToken,
    },
    (resource) => {
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.chatRoomDto);
      }
    },
    (error) => {
      // console.debug(response);
      if (failureCallbackFunction) {
        failureCallbackFunction(error);
      }
    },
  );
};
const emailDigestService = {...service};
export default emailDigestService;
